<template>
  <div>
    <el-form :model="formObject" :rules="rules" ref="adDetailForm" label-width="80px" size="mini">
      <el-form-item label="广告位置" prop="type">
        <el-select v-model="formObject.type" placeholder="广告位置" :disabled="type === 2" >
          <el-option v-for="item in locations" :key="item.id" :label="item.text" :value="item.id"/>
        </el-select>
      </el-form-item>

      <el-form-item label="广告标题" prop="mainTitle">
        <el-input v-model="formObject.mainTitle" :readonly="type === 2" clearable/>
      </el-form-item>

      <el-form-item label="副标题" prop="subTitle">
        <el-input v-model="formObject.subTitle" :readonly="type === 2" clearable/>
      </el-form-item>

      <el-form-item label="状态" prop="flag">
        <el-radio-group v-model="formObject.flag" :disabled="type === 2">
          <el-radio label="1">启用</el-radio>
          <el-radio label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="内容类型" prop="urlType">
        <el-radio-group v-model="formObject.urlType" :disabled="type === 2" @change="agreeChange">
          <!-- <el-radio label="8">新商城</el-radio>
          <el-radio label="1">商城详情</el-radio>
          <el-radio label="3">商城首页</el-radio>
          <el-radio label="2">抽奖</el-radio>
          <el-radio label="0">定制H5</el-radio> -->
          <el-radio label="4">普通H5</el-radio>
          <!-- <el-radio label="5">红包</el-radio>
          <el-radio label="6" class="mgt-10">点滴</el-radio>
          <el-radio label="7" class="mgt-10">合集页</el-radio>
          <el-radio label="9" class="mgt-10">嘉饰家</el-radio> -->

        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="业务类型" prop="mallUrlType" v-if="formObject.urlType=='8'">
        <el-radio-group v-model="formObject.mallUrlType">
          <el-radio :label=1>BBC</el-radio>
          <el-radio :label=2>拎包居家O2O</el-radio>
          <el-radio :label=3>社区商业O2O</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="发布时间">
        <el-col :span="11">
          <el-form-item prop="beginDate">
            <el-date-picker
              :readonly="type === 2"
              type="datetime"
              placeholder="开始时间"
              v-model="formObject.beginDate"
              clearable
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col class="line txt-center" :span="2">-</el-col>
        <el-col :span="11">
          <el-form-item prop="finishDate">
            <el-date-picker
              :readonly="type === 2"
              type="datetime"
              placeholder="结束时间"
              clearable
              v-model="formObject.finishDate"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-form-item>

      <el-form-item label="长期有效" prop="dateState">
        <el-radio-group v-model="formObject.dateState" :disabled="type === 2">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="游客可见" prop="isVisit">
        <el-radio-group v-model="formObject.isVisit" :disabled="type === 2">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item label="上传图片" prop="imgUrl">
        <el-upload
          action="/file/api/v1/file/upload"
          list-type="picture-card"
          :show-file-list="false"
          :file-list="fileList"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
        >
          <img :src="formObject.imgUrl" class="avatar" v-if="formObject.imgUrl"/>
          <i class="el-icon-plus avatar-uploader-icon" v-else></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="链接模板" prop="linkTemplate">
        <el-input
          v-model="formObject.linkTemplate"
          placeholder="链接模板中应包含通配符*,例:https://*.mall.justbon.com.cn/item-7828.html"
          type="text"
          :readonly="type === 2"
        />
      </el-form-item>
    </el-form>
    <div>
      <h3 class="txt-center">项目列表</h3>
      <div v-if="type === 1 || type === 0">
        <el-popover placement="top-start" width="800" v-model="popShow" trigger="click">
          <!--项目穿梭框 START-->
          <el-transfer
            filterable
            :filter-method="queryProject"
            :props="{key:'projectID',label:'name'}"
            filter-placeholder="请输入项目名称"
            v-model="selectProjects"
            v-loading="proLoading"
            :data="projects"
            class="project_transfer"
          >
            <span slot-scope="{ option }" :title="option.name">{{ option.name }}</span>
          </el-transfer>
          <!--项目穿梭框 END-->
          <div class="mgt-10 txt-right">
            <el-button size="mini" type="text" @click="cancel">取消</el-button>
            <el-button type="primary" size="mini" @click="select">确定</el-button>
          </div>

          <el-button icon="el-icon-edit" slot="reference" size="mini">编辑</el-button>
        </el-popover>
        <el-button icon="el-icon-delete" class="mgl-10" @click="deleteItem" size="mini">删除</el-button>
        <el-button icon="el-icon-tickets" size="mini" @click="patchEdit">批量编辑链接</el-button>
      </div>
      <el-table :data="formObject.projects" ref="projectList" stripe style="width: 100%">
        <el-table-column v-if="type !== 2" type="selection" width="55"/>
        <el-table-column prop="projectName" label="名称" width="300"/>
        <el-table-column prop="linkAdd" label="链接" width>
          <template slot-scope="scope">
            <el-input
              :disabled="type === 2"
              v-model="scope.row.linkAdd"
              placeholder="请输入链接"
              size="mini"
              clearable
              @blur="httpsVal"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="dialog-footer mgt-10 txt-right">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" v-if="type !== 2" type="primary" @click="finishDialog">确 定</el-button>
    </div>
  </div>
</template>

<script>
import {types} from "@/components/advertising/adMixins";
import {utils, Message} from "@/components";
import moment from 'moment'

export default {
  name: "AdDetail",
  props: {
    formObject: {
      type: Object,
      required: true
    },
    // 0: 新增,1: 修改,2:查看
    type: {
      type: Number,
      default: 0
    }
  },
  watch: {
    type: function () {
      switch (this.type) {
        case 0:
          this.$refs["adDetailForm"].resetFields();
          break;
        default:
          break;
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      popShow: false,
      proLoading: false,
      locations: types,
      projects: [],
      batchId: [],
      selectProjects: [],
      queryProject(query, item) {
        return item.name.indexOf(query) > -1;
      },
      rules: {
        type: [{required: true, message: "必填项", trigger: "change"}],
        mainTitle: [{required: true, message: "必填项", trigger: ["change","blur"]}],
        subTitle: [{required: true, message: "必填项", trigger: ["change","blur"]}],
        flag: [{required: true, message: "必填项", trigger: "change"}],
        urlType: [{required: true, message: "必填项", trigger: "change"}],
        beginDate: [{required: true, message: "必填项", trigger: "change"}],
        finishDate: [{required: true, message: "必填项", trigger: "change"}],
        dateState: [{required: true, message: "必填项", trigger: "change"}],
        imgUrl: [{required: true, message: "必填项", trigger: "change"}],
        mallUrlType: [{required: true, message: "必填项", trigger: "change"}],
        isVisit: [{required: true, message: "必填项", trigger: "change"}],
      }
    };
  },
  created() {
    this.proLoading = true;
    this.$store
      .dispatch("adbanner/getProjectsByUser")
      .then(result => {
        this.projects = result;
      })
      .finally(() => (this.proLoading = false));
  },
  computed: {
    fileList() {
      if (!this.formObject.imgUrl) return [];
      return [{id: 0, url: this.formObject.imgUrl}];
    }
  },
  methods: {
    httpsVal() {
      console.log(1)
    },
    handleRemove() {
      this.formObject.imgUrl = "";
    },
    handleSuccess(res) {
      this.$set(this.formObject,"imgUrl",res.data.fileUrl)
    },
    cancel() {
      this.popShow = false;
    },
    select() {
      this.formObject.projects = [];
      this.popShow = false;
      this.projects.forEach(project => {
        if (this.selectProjects.indexOf(project.projectID) > -1) {
          var p = {
            projectName: project.name,
            projectId: project.projectID,
            linkAdd: ""
          };
          if (utils.isNotEmpty(this.formObject.id)) {
            p.adId = this.formObject.id;
          }
          this.formObject.projects.push(p);
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
    finishDialog() {
      this.$refs["adDetailForm"].validate(valid => {
        if (valid) {
          this.formObject.beginDate = moment(this.formObject.beginDate).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.formObject.finishDate = moment(
            this.formObject.finishDate
          ).format("YYYY-MM-DD HH:mm:ss");
          this.$emit("finish");
          return true;
        } else {
          Message.warning({message: "请正确填写表单项"});
          return false;
        }
      });
    },
    repeatCheck(arr1, arr2) {
      return arr1.filter(item => {
        return !arr2.some(c => c.projectId == item.projectId);
      });
    },
    deleteItem() {
      if (this.$refs.projectList.store.states.selection.length == 0) {
        Message.warning("请至少选择一条数据。");
        return;
      }
      let temp = JSON.parse(
        JSON.stringify(
          this.repeatCheck(
            this.formObject.projects,
            this.$refs.projectList.store.states.selection
          )
        )
      );
      this.formObject.projects = temp;
      this.$forceUpdate(); //进行强制渲染
    },
    patchEdit() {
      if (this.formObject.linkTemplate == undefined)
        this.formObject.linkTemplate = "";
      let selectedData = this.$refs.projectList.store.states.selection;
      let temp = JSON.parse(JSON.stringify(this.formObject.linkTemplate));
      if (selectedData.length > 0) {
        // let scope = this;
        selectedData.forEach(function (item) {
          // if (scope.batchId[item.projectId]) {
          //   item.linkAdd = temp.replace("*", scope.batchId[item.projectId]);
          // } else {
            item.linkAdd = temp.replace("*.", '');
          // }
        });
      } else {
        Message.warning("请至少选择一条数据。");
      }
    },
    beforeUpload(file) {
      let imgTypes = ["image/jpeg", "image/png", "image/gif", "image/jpg"];
      let type = file.type.toLowerCase();
      let isImage = imgTypes.indexOf(type) > -1;
      isImage || Message.warning("上传文件只能是 JPG,JPEG,PNG,GIF 格式");
      return isImage;
    }
  }
};
</script>

